module.exports = __webpack_public_path__ + "static/media/adserver_section4_mobile.107b15ba.png";